// Results.js
import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import db from "./firebase";
import { getDatabase, ref, get, push } from "firebase/database";
import { TheFooterFunction } from "./Footer";
import { TheNavbar } from "./Navbar";
import { AuthContext } from "./App";

export function Results() {
  const { state } = useLocation();
  const { major } = state;
  const [majorInfo, setMajorInfo] = useState(null);

  useEffect(() => {
    const fetchMajorData = async () => {
      const majorRef = ref(db, major);
      get(majorRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            setMajorInfo(snapshot.val());
          } else {
            console.log("No data available");
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };
    fetchMajorData();
  }, [major]);

  const { currentUser } = useContext(AuthContext);

  const addToProfile = (selectedMajor) => {
    if (!currentUser) return;
    const db = getDatabase();
    const majorRef = ref(db, `profiles/${currentUser.uid}/potentialMajors`);

    get(majorRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const existingMajors = snapshot.val();
          let majorExists = false;

          Object.values(existingMajors).forEach((major) => {
            if (major.name === selectedMajor.name) {
              majorExists = true;
              alert("This major has already been added to your profile.");
            }
          });

          if (!majorExists) {
            push(majorRef, selectedMajor)
              .then(() => alert("Major added to your profile!"))
              .catch((error) =>
                console.error("Could not add major to profile", error)
              );
          }
        } else {
          push(majorRef, selectedMajor)
            .then(() => alert("Major added to your profile!"))
            .catch((error) =>
              console.error("Could not add major to profile", error)
            );
        }
      })
      .catch((error) =>
        console.error("Error checking for existing majors", error)
      );
  };

  if (!majorInfo) return <div>Loading...</div>;

  return (
    <main className="results-main">
      <TheNavbar />
      <div className="title-results">
        <h1 className="fw-bold custom-color">Test Results</h1>
      </div>
      <div className="flexbox-containers text-center">
        <div className="row">
          <div className="col flexbox-items items-1">
            <h2 className="fs-4">
              Your Major Match is:{" "}
              <span className="fw-bold custom-color">{major}</span>
            </h2>
            <p>{majorInfo.description}</p>
            <button
              onClick={() =>
                addToProfile({
                  name: major,
                  description: majorInfo.description,
                })
              }
              className="btn button-back"
            >
              Add to Profile
            </button>
          </div>
        </div>
      </div>
      <div className="title-results">
        <h2>Similar Majors</h2>
      </div>
      <div className="flexbox-container text-center">
        <div className="row">
          {majorInfo.similarMajors &&
            majorInfo.similarMajors.map((similarMajor, index) => (
              <div key={index} className="col flexbox-item items-2">
                <h4 className="fw-bold">{similarMajor.name}</h4>
                <img src={similarMajor.image} alt={similarMajor.name} />
                <button
                  onClick={() => addToProfile(similarMajor)}
                  className="btn button-back"
                >
                  Add to Profile
                </button>
              </div>
            ))}
        </div>
      </div>
      <TheFooterFunction />
    </main>
  );
}
